import React from 'react';

export default function MotivoSquareLogo({
  color = '#AA3965',
  width = 45,
  height = 46,
}: {
  color?: string;
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 45 46"
      fill="none"
    >
      <g fill={color} clipPath="url(#a)">
        <path d="M37.527 45.5H7.474C3.353 45.5 0 42.147 0 38.026V7.974C0 3.853 3.353.5 7.474.5h30.052C41.647.5 45 3.853 45 7.974v30.052c0 4.121-3.353 7.474-7.474 7.474h.001ZM7.474 3.585a4.393 4.393 0 0 0-4.389 4.389v30.052a4.394 4.394 0 0 0 4.39 4.389h30.051a4.393 4.393 0 0 0 4.389-4.389V7.974a4.393 4.393 0 0 0-4.389-4.389H7.474Z" />
        <path d="M8.746 16.995a4.146 4.146 0 0 1 7.687 1.138 17.83 17.83 0 0 1 1.858-2.085c2.388-1.981 5.893-1.464 6.949 2.274.379-.53.689-1.066 1.088-1.525a4.783 4.783 0 0 1 4.582-1.806 4.286 4.286 0 0 1 3.271 4.033c.107 2.216.063 4.44.159 6.657a3.091 3.091 0 0 0 1.627 2.953c.534.261.202.628 0 .88a4.092 4.092 0 0 1-3.053 1.612 4.204 4.204 0 0 1-4.633-3.728c-.021-.198-.028-.399-.021-.599-.042-1.883-.007-3.768-.022-5.653a5.212 5.212 0 0 0-.123-1.2.948.948 0 0 0-1.718-.468c-.648.671-.99 1.58-.948 2.511.035 2.646.09 5.291.19 7.936.021.555-.11.683-.642.675-1.836-.03-3.672-.011-5.605-.011v-.758c0-2.895 0-5.788-.009-8.682a3.14 3.14 0 0 0-.131-1.122c-.134-.34-.415-.827-.678-.858a1.542 1.542 0 0 0-1.145.463 3.76 3.76 0 0 0-.864 2.615c-.013 2.513-.006 5.021-.008 7.537v.766h-6.206v-.69c.05-2.96.108-5.92.141-8.88a8.832 8.832 0 0 0-.153-1.532 2.836 2.836 0 0 0-1.594-2.18l.002-.274Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 .5h45.001v45H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
